module.exports = __webpack_public_path__ + "static/drink200-5e96210f18fcb05387b5a664ea4a53f4.png";